import styled from '@emotion/styled';
import { ListItem, ListItemAvatar, ListItemText as _ListItemText, Typography, useMediaQuery } from '@material-ui/core';
import { createElement, FC, Fragment, MouseEvent } from 'react';

import { ProjectTypeForListFragment } from '../../../../generated/graphql';
import theme from '../../../../theme';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import mq from '../../../styleUtility/mediaquery';
import ImageScreen from '../../primitive/ImageScreen';
import VideoScreen from '../../primitive/VideoScreen';

type Props = {
  projectType: ProjectTypeForListFragment;
  onSelect: (e: MouseEvent<HTMLElement>, projectType: ProjectTypeForListFragment) => void;
  className?: string;
};

const Item: FC<Props> = ({ projectType, onSelect, className }) => {
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['md']}px)`);

  return (
    <>
      {!isPC ? <ProjectTitle variant="h6">{projectType.title}</ProjectTitle> : null}
      <Root
        button
        onClick={(e) => {
          onSelect(e, projectType);
        }}
        className={className}
      >
        <ListItemText
          primary={projectType.title && isPC ? <ProjectTitle variant="h6">{projectType.title}</ProjectTitle> : null}
          secondary={
            <>
              {projectType.description ? (
                <ProjectDescription variant="body2" component="span">
                  {projectType.description}
                </ProjectDescription>
              ) : null}
            </>
          }
        />
        <ListItemAvatar>
          {projectType.sampleVideoUrl ? (
            <Video
              src={projectType.sampleVideoUrl}
              nodownload
              poster={projectType.thumbnailImageUrl}
              preloadAttr="metadata"
            />
          ) : (
            <Thumbnail src={projectType.thumbnailImageUrl} />
          )}
        </ListItemAvatar>
      </Root>
    </>
  );
};

const Root = styled(ListItem)`
  cursor: pointer;
  padding: ${SPACING_REGULAR}px;

  ${mq('sp')} {
    align-items: flex-start;
  }
`;

const Video = styled(VideoScreen)`
  width: 160px;
  height: 160px;

  ${mq('sp')} {
    width: calc((160 / 560) * 100vw);
    height: calc((160 / 560) * 100vw);
  }
`;

const Thumbnail = styled(ImageScreen)`
  width: 160px;
  height: 160px;

  ${mq('sp')} {
    width: calc((160 / 560) * 100vw);
    height: calc((160 / 560) * 100vw);
  }
`;

const ProjectTitle = styled(Typography)`
  font-weight: bold;

  ${mq('sp')} {
    padding: 16px 16px 0 16px;
  }
`;

const ProjectDescription = styled(Typography)`
  margin: ${SPACING_UNIT / 2}px 0 ${SPACING_REGULAR}px;

  ${mq('sp')} {
    font-size: 0.775rem;
  }
` as typeof Typography;

const ListItemText = styled(_ListItemText)`
  ${mq('sp')} {
    margin: 0 16px 4px 0;
  }
`;

export default Item;
